export default __webpack_public_path__ + "static/media/bg_collations.d3c11885.png";